import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import {MINIMO_CARACTERES_SENHA, RequisitoSenha} from "../enum/RequisitosSenha.enum";

export interface RequisitoSenhaItem {
  id: RequisitoSenha;
  label: string;
  valid: boolean;
}

/**
 * Avalia, em tempo real, quais requisitos de segurança a senha informada atende.
 * Utilizado para exibir o feedback visual (checklist) ao usuário.
 */
export function avaliarRequisitosSenha(senha: string): RequisitoSenhaItem[] {
  const valor = senha || '';
  return [
    { id: RequisitoSenha.MinimoCaracteres, label: `Mínimo de ${MINIMO_CARACTERES_SENHA} caracteres`, valid: valor.length >= MINIMO_CARACTERES_SENHA },
    { id: RequisitoSenha.RequerLetraMaiuscula, label: 'Ao menos uma letra maiúscula', valid: /[A-Z]/.test(valor) },
    { id: RequisitoSenha.RequerLetraMinuscula, label: 'Ao menos uma letra minúscula', valid: /[a-z]/.test(valor) },
    { id: RequisitoSenha.RequerNumero, label: 'Ao menos um número', valid: /[0-9]/.test(valor) },
    { id: RequisitoSenha.RequerCaracterEspecial, label: 'Ao menos um caractere especial', valid: /[!@#$%^&*(),.?":{}|<>]/.test(valor) },
  ];
}

/** Verifica se a senha atende a todos os requisitos de segurança. */
export function senhaAtendeRequisitos(senha: string): boolean {
  return avaliarRequisitosSenha(senha).every(r => r.valid);
}

/**
 * Validador reativo que garante que a senha atenda a todos os requisitos
 * de segurança definidos para o novo padrão da PJUS.
 */
export const senhaForteValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const valor = control.value;
  if (!valor) {
    return null; // a obrigatoriedade fica a cargo do Validators.required
  }
  return senhaAtendeRequisitos(valor) ? null : { senhaFraca: true };
};

